import { Tooltip, type TooltipProps, Typography } from '@mui/material'
import React from 'react'

import Icon, { type IconProps } from 'components/Icon'

export const ReliabilityIntelligenceIcon: React.FC<
  Omit<IconProps, 'icon'> & {
    tooltipProps?: Omit<Partial<TooltipProps>, 'children'>
  }
> = ({ tooltipProps = {}, ...iconProps }) => {
  const { title: tooltipTitle, ...tooltipPropsRest } = tooltipProps

  return (
    <Tooltip
      arrow
      placement="top"
      title={tooltipTitle ?? ''}
      {...tooltipPropsRest}
    >
      <Typography color="marketingViolet650.main">
        <Icon icon="regularLightbulbExclamationOn" {...iconProps} />
      </Typography>
    </Tooltip>
  )
}

export const ReliabilityIntelligenceRunIcon = () => {
  return (
    <ReliabilityIntelligenceIcon
      tooltipProps={{ title: 'Reliability Intelligence diagnosis available' }}
    />
  )
}
